import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './SparkSyncSuspendButton.scss';

interface SparkSyncSuspendButtonProps {
  sparkSyncSuspended: boolean;
  isTogglingSuspend: boolean;
  onToggleSuspend: () => void;
}

const SparkSyncSuspendButton = ({
  sparkSyncSuspended,
  isTogglingSuspend,
  onToggleSuspend,
}: SparkSyncSuspendButtonProps) => {
  return (
    <div className="spark-sync-suspend">
      <span className="spark-sync-suspend-label">
        {sparkSyncSuspended ? 'Reactivate Spark Sync' : 'Suspend Spark Sync'}
      </span>
      <button
        className="spark-sync-suspend-btn"
        onClick={onToggleSuspend}
        disabled={isTogglingSuspend}
        title={sparkSyncSuspended ? 'Reactivate Sync' : 'Suspend Sync'}
      >
        <FontAwesomeIcon
          glyph={sparkSyncSuspended ? 'play-circle' : 'pause-circle'}
          weight="solid"
        />
      </button>
    </div>
  );
};

export default SparkSyncSuspendButton;